import axios from 'axios'
import { Message } from 'element-ui'
import { BASE_API } from '@/config'
import store from '@/store'
import router from '@/router'
import { getAuth, clearAuth } from '@/utils/auth'

const service = axios.create({
  baseURL: BASE_API,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

service.interceptors.request.use(
  (config) => {
    const auth = getAuth()
    if (auth && auth.token) {
      config.headers.token = auth.token
    }
    return config
  },
  (error) => Promise.reject(error)
)

service.interceptors.response.use(
  (response) => {
    const res = response.data

    if (res && typeof res.code !== 'undefined') {
      if (res.code === 1) {
        return res
      }
      Message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }

    return res
  },
  (error) => {
    const msg = (error.response && error.response.data && error.response.data.msg) || error.message || '网络异常'
    if (error.response && error.response.status === 401) {
      store.dispatch('websocket/closeWebSocket').catch(() => {})
      clearAuth()
      store.commit('CLEAR_AUTH')
      if (router.currentRoute.path !== '/login') {
        router.replace('/login')
      }
    }
    Message.error(msg)
    return Promise.reject(error)
  }
)

export default service
